export const BASEPATH = window.location.origin;
export const BASKETPATH = (typeof basketPath !== 'undefined') ? basketPath : BASEPATH;
export const CHECKOUTPATH = (typeof checkoutPath !== 'undefined') ? checkoutPath : BASEPATH;

export const ALERT_SUCCESS_CLASS = 'msg-box-success';
export const ALERT_ERROR_CLASS = 'msg-box-error';
export const ALERT_CLASS = 'msg-box';
export const HIDE_ELEMENT_CLASS = 'hide';

export const ELEMENT_HAS_ERROR_CLASS = 'has-error';
export const ELEMENT_ERROR_BLOCK_SELECTOR = '.help-block';

export const SPINNER_ACTIVE = 'spinner-active';

export const MDL_TOOLTIP_CLASS = 'mdl-tooltip';
export const MDL_TEXTFIELD_INPUT_CLASS = 'mdl-textfield__input';
export const MDL_TEXTFIELD_CLASS = 'mdl-js-textfield';
export const MDL_TEXTFIELD_LABEL_CLASS = 'mdl-textfield__label';
export const MDL_TEXTFIELD_FLOATING_LABEL_CLASS = 'mdl-textfield--floating-label';
export const MDL_SELECTFIELD_CLASS = 'mdl-selectfield';
export const MDL_SELECTFIELD_REQUIRED_CLASS = 'mdl-selectfield-required';
export const MDL_SELECTFIELD_SELECT_CLASS = 'mdl-selectfield__select';
export const MDL_SELECTFIELD_VALUE_CLASS = 'mdl-selectfield__box-value';
export const MDL_MULTILINE_LABEL_CLASS = 'mdl-multi-line-label';
export const MDL_DIRTY_CLASS = 'is-dirty';
export const MDL_VALID_CLASS = 'is-valid';
export const MDL_INVALID_CLASS = 'is-invalid';
